import Repository from '../Repository';

const url = '/goals';

export default {
    getGoals() {
        return Repository.get(`${url}/`, {
            localLoading: true
        });
    },
}
